import React, { ReactNode } from 'react';
import classNames from 'classnames';
import styles from './table-heading-basic.module.scss';

type Props = {
  className?: string;
  children?: ReactNode;
  lightHeader: boolean;
  alignment?: 'left' | 'right';
};

export const TableHeadingBasic: React.FC<Props> = ({ children, lightHeader, className, alignment }) => {
  return (
    <div
      role="columnheader"
      className={classNames(
        styles.root,
        { [styles.lightHeader]: lightHeader, [styles.right]: alignment === 'right' },
        className,
      )}
    >
      {children}
    </div>
  );
};
